export default () => ({
  title: "AllowAccessHiddenTeamByLink",
  type: "object",
  expanded: true,
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
  },
});
